export default "__VITE_ASSET__D1It1EA5__"